import { Tooltip } from '@mui/material';

import { ChipInformativo } from '../../Presentaciones/components/PresentationStateChip';
import { AVISO_AMBAR } from './VigenciaBadge';

/**
 * Informes cuya carga se apartó de lo que la SRT tiene declarado.
 *
 * Es el aviso que faltaba para el caso más común del circuito: el empleador
 * contrata a alguien —o da de baja a otro— dentro de un período que ya se
 * presentó. La declaración vigente queda desactualizada y hasta acá nada lo
 * decía, porque ese cambio no dejaba rastro en la base.
 *
 * El número sale de comparar la huella de lo que se enviaría hoy contra la de lo
 * último enviado, así que cuenta sólo lo comprobado: los informes que nunca se
 * enviaron, o los enviados antes de que se guardara la huella, no suman. Ese
 * recorte es a propósito — un contador que incluyera lo no comprobable mandaría
 * a revisar presentaciones que están bien.
 */
const NovedadesChip = ({ informes }: { informes: number }) => {
    if (!informes) return null;

    const plural = informes === 1 ? 'informe' : 'informes';

    return (
        <Tooltip
            title={`Lo cargado ya no coincide con lo declarado ante la SRT en ${informes} ${plural} —por ejemplo un trabajador dado de alta o de baja después de presentar—. Se informa con una modificación sobre la presentación vigente.`}
        >
            {/*
              * Mismo chip que el resto de la grilla —`ChipInformativo` comparte
              * el `sx` con los chips de estado— y el ámbar que la app ya usa
              * para "pendiente". Antes era un `color="warning"` de MUI, que es
              * otro naranja y otro borde.
              */}
            <span style={{ cursor: 'help' }}>
                <ChipInformativo
                    label={`${informes} ${plural} con novedades`}
                    paleta={AVISO_AMBAR}
                    testId="novedades-sin-informar"
                />
            </span>
        </Tooltip>
    );
};

export default NovedadesChip;
